export default "<app-product-list>Loading ...</app-product-list>\n"